import { usePracticeAccess } from '@hb/react'
import { LAB_RESULTS, LabResult, USERS } from '@hb/shared'
import { collection, CollectionReference, query, where } from 'firebase/firestore'
import { useMemo } from 'react'
import { db } from '../../../backend/db'
import { useQuery } from '../useQuery'

// Returns lab results scoped to the neonatal record (recordType === 'neonatal').
// Client-side filter avoids requiring a composite Firestore index.
export const useNeonatalLabResults = (
  patientId: string | null | undefined,
  assessmentId: string | null | undefined,
) => {
  const { selectedPracticeId } = usePracticeAccess()
  const ref = useMemo(() => {
    if (!assessmentId || !patientId) return null
    const col = collection(db, USERS, patientId, LAB_RESULTS) as CollectionReference<LabResult>
    if (selectedPracticeId) {
      return query(
        col,
        where('assessmentId', '==', assessmentId),
        where('practiceId', '==', selectedPracticeId),
      )
    }
    return query(col, where('assessmentId', '==', assessmentId))
  }, [assessmentId, selectedPracticeId, patientId])

  const result = useQuery<LabResult>(ref)

  const neonatalResults = useMemo(
    () => (result.dataArr ?? []).filter(r => r.recordType === 'neonatal'),
    [result.dataArr],
  )

  return { ...result, dataArr: neonatalResults }
}
